const shallowEqualArrays = require("shallow-equal/arrays");
const shallowEqualObjects = require("shallow-equal/objects");

const shallowEq = function(a, b) {
	if (Array.isArray(a)) {
		return Array.isArray(b) && shallowEqualArrays(a, b);
	} else if (a && typeof a === "object") {
		return b && typeof b === "object" && shallowEqualObjects(a, b);
	} else {
		return a === b;
	}
};

const shallowEqOnKeys = function(a, b, keys) {
	return keys.every(k => a[k] === b[k]);
};

// Debugging aid. Console logs unequal keys. Mark with a triple x comment when
// you use it so that we don't release a use of it.
const shallowEqOnKeysDebug = function(a, b, keys, label) {
	return keys.every(k => {
		if (a[k] === b[k]) {
			return true;
		}
		// eslint-disable-next-line no-console
		console.log("shallowEqOnKeysDebug " + (label || "") + ": Unequal on " + k);
		return false;
	});
};

module.exports = {
	shallowEq,
	shallowEqOnKeys,
	shallowEqOnKeysDebug,
};
